/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import {EarningsAccountCopyModalComponent} from './earnings-account-copy-modal.component';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {getCountryName} from '../common/directives/country-select/countries';
import {PERMISSIONS} from '../../components/auth/auth-constants';
import _ from 'lodash';
import {EarningsAccountResource} from '../../components/api/resources/resource/earnings-account.resource';
import {SiteResource} from '../../components/api/resources/resource/site.resource';



export function earningsAccountStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('earnings-accounts.earnings-account', EarningsAccountResource, SiteResource, 'app.inv', 'app');
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'EarningsAccount',
          editTag: 'adn-earnings-account-edit-page',
          twoPanel: {
            rightTag: 'adn-earnings-account-analysis-page'
          },
          listTag: 'adn-earnings-account-list-page',
          listResolve: {
            extension: /*@ngInject*/ function() {
              const LocalNetworkProfile = adnRouterHelper.services.localNetworkProfile();
              const localUserProfile = adnRouterHelper.services.localUserProfile();

              return {
                func: function(ctrl, afterFill) {
                  if (afterFill) {
                    _.forEach(ctrl.items, function(item) {
                      item.countriesExpanded = _.map(item.countries || [], function(country) {
                        return getCountryName(country);
                      }).join(', ');
                    });
                    return;
                  }
                  ctrl.eaFields = ['name'];
                  if (LocalNetworkInfo.obtain().getSiteCountries().length > 1) {
                    ctrl.eaFields.push({label: 'countries', param: ''});
                  }
                  ctrl.eaFields.push('externalReference');
                  ctrl.eaFields.push('revenueShare');
    
                  const isSpecialUser = localUserProfile.get('username') === 'adnuntius@adnuntius.com'
                    || localUserProfile.get('username') === 'broker1@adnuntius.com';
                  if (LocalNetworkProfile.isPureMarketplacePlatform() && isSpecialUser) {
                    ctrl.eaFields.push({label: 'fullPage', param: ''});
                  }
                }
              };
            },
            readOnly: /*@ngInject*/ function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.managePublishing.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.axPublisherAdmin.apiKey);
            }
          },
          itemResolve: {
            blockDelete: /*@ngInject*/ function(readOnly) {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return readOnly || LocalUserPermissions.isAnyAxPublisher();
            },
            copyConfig: function() {
              return {
                modalComponent: EarningsAccountCopyModalComponent,
                stateUrl: 'app.inv.earnings-accounts.earnings-account',
                lcase: 'earningsAccount',
                ucase: 'EarningsAccount'
              };
            }
          }
        });
  }, adnRouterHelper);
}
